import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import '../debtPayment.scss'
import BasicText from '../DebtPaymentComponents/basicText'
import RadioInput from '../../../Shared/RadioInput/RadioInput';
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import { CSSTransition } from 'react-transition-group'

const CompanyTypeSelect = (props) => {
    useEffect(() => {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_COMPANYTYPE.category,
          gaParams.DEBT_PAYMENT_SHOW_COMPANYTYPE.eventType,
          gaParams.DEBT_PAYMENT_SHOW_COMPANYTYPE.eventParams
        );
      }, []);

      const invokeClick = (e) => {
        e.currentTarget.getElementsByClassName('radio-custom')[0].click()
      }

    return (
        <Container className='debtpayment-select-box'>
          <Row className='justify-content-md-center'>
            <Col lg='4' className='select-box'>
              <BasicText bold text={props.text} />
              {props.radioBtns.map((btn) => (
                <div className='radio-btn-item' key={btn.id} onClick={(e) => invokeClick(e)}>
                  <RadioInput
                    checked={props.selectedProvider == btn.value}
                    id={btn.id}
                    name='consumer'
                    value={btn.value}
                    label={btn.label}
                    onChange={props.onRadioBtnChange}
                  />
                </div>
              ))}
            </Col>
          </Row>
        </Container>
   
    );
}

export default CompanyTypeSelect;
